import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

type StyledProps = {
  isVideo: boolean;
  gallery: boolean;
};

export const HeaderWrapper = styled.div<StyledProps>`
  background-color: ${({ isVideo, theme, gallery }) =>
    (isVideo && theme.default.color.backgrounds.light) ||
    (gallery && theme.default.color.backgrounds.light)};
  height: 100%;
  p {
    margin: 10px 0 32px 0;
    color: ${({ theme }) => theme.default.color.text.medium};
    font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    @media (max-width: ${defaultBreakpoints.medium}) {
      font-size: 20px;
      margin: 12px 0 24px 0;
    }
  }
`;

export const Headline = styled.h1`
  color: ${({ theme }) => theme.default.color.text.dark};
  font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
  font-weight: 800;
  line-height: 60px;
  font-size: 52px;
  margin: 0 0 32px 0;
  text-align: left !important;
  @media (max-width: ${defaultBreakpoints.medium}) {
    font-size: 24px;
    margin: 0 0 24px 0;
    line-height: 32px;
  }
`;

export const SharingWrapper = styled.div`
  font-size: 1rem;
  svg {
    font-size: 1.4rem;
    &:hover {
      path {
        fill: ${({ theme }) => theme.default.color.primary};
      }
    }
  }
`;

export const AboutWrapper = styled.div`
  border-top: ${({ theme }) => `1px solid ${theme.default.color.text.light}`};
  border-bottom: ${({ theme }) =>
    `1px solid ${theme.default.color.text.light}`};
  padding: 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: ${defaultBreakpoints.medium}) {
  }
`;

export const AboutInnerWrapper = styled.div`
  display: flex;
`;

export const DailyMotionWrapper = styled.div`
  width: 975px;
  margin: 1rem auto;
  position: relative;
  height: 540px;

  @media (max-width: ${defaultBreakpoints.large}) {
    width: 95vw;
    height: 212px;
  }
`;

export const CommentsButton = styled.div`
  display: inline-flex;
  font-family: ${({ theme }) => theme.default.fontFamily.primaryFont};
  border: 0;
  background: ${({ theme }) => theme.default.color.primary};
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  padding: 8px 20px;
  border-radius: 24px;
  color: ${({ theme }) => theme.default.color.backgrounds.white};
  margin-bottom: 16px;
`;
